import React from "react";
import StatusChips from "./StatusChips";
import SearchBox from "./SearchBox";

export default function HeaderBar({ status, onStatusChange, query, onQueryChange, counts, onClear }) {
  return (
    <header className="lo-header">
      <h2 className="lo-title">Orders</h2>
      <div className="lo-controls">
        <div className="lo-chips">
          <StatusChips value={status} onChange={onStatusChange} counts={counts} />
        </div>
        <SearchBox value={query} onChange={onQueryChange} placeholder="Search order # or customer…" />
        <button className="btn btn-danger" onClick={onClear}>
          Clear Live Orders
        </button>
      </div>
    </header>
  );
}
